import { render, staticRenderFns } from "./menu.vue?vue&type=template&id=3e16bcd6&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"
import style0 from "./menu.vue?vue&type=style&index=0&id=3e16bcd6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e16bcd6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e16bcd6')) {
      api.createRecord('3e16bcd6', component.options)
    } else {
      api.reload('3e16bcd6', component.options)
    }
    module.hot.accept("./menu.vue?vue&type=template&id=3e16bcd6&scoped=true", function () {
      api.rerender('3e16bcd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/menu.vue"
export default component.exports